/**
 * Helper function to generate consistent avatar colors based on user info
 * @param {string} firstName - User's first name
 * @param {string} lastName - User's last name  
 * @param {string|number} id - User's ID
 * @returns {string} - Hex color code
 */
export const getAvatarColor = (firstName, lastName, id) => {
  const avatarColors = [
    '#007bff', '#28a745', '#dc3545', '#ffc107', '#6f42c1', 
    '#fd7e14', '#e83e8c', '#20c997', '#6c757d', '#17a2b8'
  ];
  
  // Create a simple hash from the user's name and ID
  const nameString = `${firstName || ''}${lastName || ''}${id || ''}`;
  let hash = 0;
  for (let i = 0; i < nameString.length; i++) {
    const char = nameString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Use the hash to select a color
  const colorIndex = Math.abs(hash) % avatarColors.length;
  return avatarColors[colorIndex];
};
